import moment from 'moment';

import templateUrl from './post-work-order-payout-modal.component.html';

export const PostWorkOrderPayoutModalComponent = {
    controller: PostWorkOrderPayoutModalController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
}

function PostWorkOrderPayoutModalController(utilityService) {
    'ngInject';
    const vm = this;

    vm.$onInit = onInit;
    vm.close;
    vm.dismiss;
    vm.filterPayout = filterPayout;
    vm.filters = {};
    vm.pageNumber = 1;
    vm.pageSize = 10;
    vm.onCancel = onCancel;
    vm.onChangePostedDate = onChangePostedDate;
    vm.onChangeSelection = onChangeSelection;
    vm.onSave = onSave;
    vm.onSelectAll = onSelectAll;
    vm.resolve;
    vm.postWorkOrderPayoutRequest;
    vm.productOrderDivisionPayouts;

    function onInit() {
        vm.postWorkOrderPayoutRequest = {
            PostedDate: new Date(),
            Division: vm.resolve.Division,
            IcdCorporation: vm.resolve.IcdCorporation,
            ProductOrders: [],
            MergePreviouslyPosted: true,
            PreventDescendingPayout: false
        };
        vm.productOrderDivisionPayouts = vm.resolve.productOrderDivisionPayouts;
        markWorkOrderDivsionPayout();
        vm.save = vm.resolve.save;
    }

    function markWorkOrderDivsionPayout() {
        // Pre-select any payouts that were already posted on the selected date.
        const isRepost = vm.productOrderDivisionPayouts.filter(payout =>
            payout.IsPosted && moment(vm.postWorkOrderPayoutRequest.PostedDate).startOf('day')
                .isSame(moment(payout.PostedDate).startOf('day'))).length > 0;
        vm.productOrderDivisionPayouts.forEach(function (payout) {

            if (isRepost && payout.IsPosted && moment(vm.postWorkOrderPayoutRequest.PostedDate).startOf('day')
                .isSame(moment(payout.PostedDate).startOf('day'))) {
                payout.Selected = true;
            } else if (!isRepost && !payout.IsPosted) {
                payout.Selected = true;
            } else {
                payout.Selected = false;
            }
        });
        calculateTotals();
    }

    function onChangePostedDate() {
        markWorkOrderDivsionPayout();
    }

    function onChangeSelection() {
        calculateTotals();
    }

    function onSelectAll() {
        vm.productOrderDivisionPayouts.filter(filterPayout).forEach(function (payout) {
            payout.Selected = vm.selectAll;
        });
        calculateTotals();
    }

    function onCancel() {
        vm.dismiss({ $value: 'cancel' });
    }

    function calculateTotals() {

        vm.workOrderTotals = vm.productOrderDivisionPayouts.filter(function (payout) {
            return payout.Selected;
        }).reduce(function (totals, payout) {
            totals.DivisionPayoutAmount += payout.TotalAmount;
            totals.IcdPayoutAmount += payout.OfficeTotalAmount;
            totals.RepPayoutAmount += payout.RepTotalAmount;

            return totals;
        }, { DivisionPayoutAmount: 0, IcdPayoutAmount: 0, RepPayoutAmount: 0 });
    }

    function onSave() {
        const productOrders = vm.productOrderDivisionPayouts.filter(function (payout) {
            return payout.Selected;
        }).map(function (payout) {
            return payout.ProductOrderID;
        });
        vm.postWorkOrderPayoutRequest.ProductOrders = productOrders;
        vm.save(vm.postWorkOrderPayoutRequest)
            .then(function () {
                vm.close({ $value: vm.postWorkOrderPayoutRequest });
                return vm.postWorkOrderPayoutRequest;
            });
    }

    function filterPayout(payout) {
        const employeeSearch = !payout.Employee ? "" : payout.Employee.FirstName + " " + payout.Employee.LastName;
        return (!vm.filters.owner || utilityService.containsInvariant(payout.OwnerName, vm.filters.owner))
            && (!vm.filters.clientName || utilityService.containsInvariant(payout.ClientName,
                vm.filters.clientName))
            && (!vm.filters.salesRep || !payout.Employee || utilityService.containsInvariant(employeeSearch,
                vm.filters.salesRep))
            && (!vm.filters.orderDate || moment(vm.filters.orderDate).isSame(payout.OrderDate, "day"))
            && (!vm.filters.accountNumber || utilityService.containsInvariant(
                payout.AccountNumber, vm.filters.accountNumber))
            && (!vm.filters.productCode || utilityService.containsInvariant(
                payout.ProductCode, vm.filters.productCode))
            && (!vm.filters.productDescription || utilityService.containsInvariant(
                payout.ProductDescription, vm.filters.productDescription))
            && (!vm.filters.productLineName || utilityService.containsInvariant(
                payout.ProductLineName, vm.filters.productLineName))
            && (!vm.filters.typeOfPayout || utilityService.containsInvariant(
                payout.TypeOfPayout, vm.filters.typeOfPayout))
            && (!vm.filters.postedDate || moment(payout.PostedDate).isSame(vm.filters.postedDate, "day"))
            && (!vm.filters.payrollEndDate || moment(payout.PayWeekEndDate)
                .isSame(vm.filters.payrollEndDate, "day"));
    }
}
